import { ChangeDetectionStrategy, Component, Input, OnInit, Injector } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * SiteInformation Widget
 */
@Component({
  selector: 'site-information-widget',
  templateUrl: './site-information-widget.component.html',
  styleUrls: ['./site-information-widget.component.scss', '../../common/css/general.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteInformationWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'siteInformation', true);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    const self = this; //Kendo - keep it
    this.textAreaOptions = {
      change: function () {
        self.setDirtyFlag(true);
      },
      update: function (text) {
        self.widgetData.Comment = text;
      },
    };

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("siteInformation", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.loadReflist('ref_site_servicing');
    this.loadReflist('ref_site_layout');
    this.loadReflist('ref_soil_contamination');
    this.loadReflist('ref_building_encumbrances');
    this.loadReflist('ref_hereditary_building_right');

    this.mockupData$ = this.widgetService.loadMockup('siteinformation').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('siteinformation', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }


}
